import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography
} from "@mui/material";

/**
 * Dialog component that confirms permanent ID generation for wood suppliers
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.open - Controls whether the dialog is open or closed
 * @param {Function} props.onClose - Function called when dialog is closed without confirmation
 * @param {Function} props.onConfirm - Function called when user confirms the action
 * @returns {React.ReactElement} - Dialog component
 */
const GeneratePermanentIDDialog = ({ open, onClose, onConfirm }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '8px',
                    padding: 0,
                    minHeight: 'fit-content',
                    maxHeight: 'fit-content'
                }
            }}
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '0 16px',
                    backgroundColor: '#102A62',
                    margin: 0,
                    width: '100%',
                    height: '50px',
                    boxSizing: 'border-box',
                    textAlign: 'center'
                }}
            >
                <Typography
                    sx={{
                        color: '#FFFFFF',
                        fontFamily: 'Montserrat',
                        fontWeight: 600,
                        fontSize: '20px',
                        textAlign: 'center'
                    }}
                >
                    Generate Permanent IDs
                </Typography>
            </DialogTitle>
            <DialogContent
                sx={{
                    padding: '20px',
                    overflow: 'hidden',
                    marginTop: '20px',
                }}
            >
                <Typography
                    sx={{
                        color: '#000000DE',
                        fontFamily: 'Montserrat',
                        fontSize: '16px',
                        lineHeight: '24px',
                        marginBottom: '20px'
                    }}
                >
                    Permanent IDs will be generated only for the selected Wood Suppliers who do not already have a permanent ID. Do you want to proceed?
                </Typography>
            </DialogContent>
            <DialogActions
                sx={{
                    padding: '0 20px 20px 20px',
                    justifyContent: 'center',
                    gap: 6
                }}
            >
                <Button
                    onClick={onClose}
                    variant="outlined"
                    sx={{
                        color: 'white',
                        borderColor: '#62636C',
                        background: '#62636C',
                        textTransform: 'none',
                        fontFamily: 'Montserrat',
                        height: "46px",

                        '&:hover': {
                            color: 'white',
                            background: '#62636C',
                        }
                    }}
                >
                    No
                </Button>
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    sx={{
                        backgroundColor: '#004F9F',
                        height: "46px",

                        color: 'white',
                        textTransform: 'none',
                        fontFamily: 'Montserrat',
                        '&:hover': {
                            backgroundColor: '#004F9F'
                        }
                    }}
                >
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default GeneratePermanentIDDialog;